export default "__VITE_ASSET__21c6110b__"